






























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import omit from 'lodash/omit';
import keyBy from 'lodash/keyBy';
import find from 'lodash/find';

import { Validators } from 'shared/utils/validator';
import { RoleNames, Role } from 'shared/utils/constants';

import AppActionStepsDialog from './components/StepItems/ActionStepsDialog.vue';
import AppOfferDialog from 'shared/components/Static/OfferDialog.vue';
import AppPrivacyDialog from 'shared/components/Static/PrivacyDialog.vue';

import { state } from './util/state';
import { AppState } from './util/app-state';

@Component({
  name: 'AppEgrnFreeForm',

  props: {
    formType: {
      type: String,
      default: 'advanced',
    },
    getProducts: Function,
  },
})
export default class EgrnFreeForm extends Vue {
  // props
  formType!: 'simple' | 'advanced' | string;
  getProducts!: (state: AppState['form']) => Promise<Product[]>;

  // data
  showPhone: boolean = false;
  roles: typeof RoleNames = {
    ...omit(RoleNames, Role.Admin, Role.Partner),
    [Role.Agent]: 'Агенство недвижимости',
    [Role.Client]: 'Другое',
  };

  // computed
  get state(): AppState {
    return state;
  }

  get loading(): boolean {
    return state.step !== 'form';
  }

  // methods
  validationRules(): ValidationConfig {
    const config: ValidationConfig = {
      query: [ Validators.required ],
      email: [ Validators.required, Validators.email ],
      privacy: [ Validators.eq(true, 'Чтобы продолжить, установите этот флажок') ],
    };

    if (this.formType === 'advanced') {
      config.target = [ Validators.notEq(0, 'Обязательное поле') ];

      if (state.form.target === 1) {
        config.phone = [ Validators.required, Validators.phone ];
        config.person_role = [ Validators.required ];
      }
    }

    if (this.formType === 'simple' && this.showPhone) {
      config.phone = [ Validators.required, Validators.phone ];
    }

    return config;
  }

  async onSubmit() {
    await this.fetchProducts();

    this.$dialog.open({ component: AppActionStepsDialog });
  }

  async fetchProducts() {
    const products = await this.getProducts(state.form);
    const egrnRightList = find(products, { product_name: 'EgrnRightList' });
    const freeCoupon: Coupon = {
      discount: '299',
      description: '100%',
      name: 'skidka100pravo',
    };

    egrnRightList.coupons = [ freeCoupon ];

    state.products.list = products;
    state.products.byName = keyBy(products, 'product_name');
    state.products.byId = keyBy(products, 'product_id');
  }

  openDialog(type: string) {
    this.$dialog.open({
      component: type === 'offer' ? AppOfferDialog : AppPrivacyDialog,
    });
  }
}
